import {
  DeviceRegistryCommandFunctionType,
  DeviceRegistryCommandKey
} from '@tryiris-ai/common.protojs/api/v1/device_settings';
import { focus } from './focus.js';
import type { Far } from './types.js';

/**
 * Focus far.
 *
 * @param deviceId - Device ID.
 * @returns A promise that resolves when the command has been processed.
 */
export const far: Far = async (deviceId) =>
  focus(deviceId, [DeviceRegistryCommandKey.FOCUS_ABSOLUTE, DeviceRegistryCommandFunctionType.UP]);
